/**
 * Strips HTML tags and normalizes Unicode styled characters (mathematical bold, italic, etc.)
 * to their plain ASCII equivalents. Used to sanitize contact names that may contain
 * formatting from form submissions.
 */
export const sanitizeName = (name: string | undefined | null): string => {
  if (!name) return ``
  let clean = name.replace(/<[^>]*>/g, ``)
  // Normalize Unicode styled characters (mathematical bold/italic/etc) to ASCII
  clean = clean.normalize(`NFKD`).replace(/[\u0300-\u036f]/g, ``)
  return clean.trim()
}
